// extracted by mini-css-extract-plugin
export default {"container":"PosterEditor_container__7Dmk6","sidebarContainer":"PosterEditor_sidebarContainer__z2tXk","editorStageContainer":"PosterEditor_editorStageContainer__dteHM"};